import React from 'react';

export const PositionCard = ({ name, description, qualities, color }) => {
  return (
    <div 
      className="position-card group"
      data-testid={`position-card-${name?.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <div className="absolute top-0 left-0 right-0 h-1" style={{ background: color }} />
      
      <div className="p-6">
        <div className="flex items-center gap-3 mb-4">
          <div 
            className="w-12 h-12 rounded-xl flex items-center justify-center text-white font-bold text-sm"
            style={{ 
              backgroundColor: color,
              fontFamily: 'Barlow Condensed, sans-serif'
            }}
          >
            {name?.split(' ').map(w => w[0]).join('').slice(0, 3)}
          </div>
          <h3 
            className="text-xl font-bold text-white uppercase tracking-wide"
            style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
          >
            {name}
          </h3>
        </div>
        
        <p className="text-slate-400 leading-relaxed mb-4">{description}</p>
        
        <div className="space-y-2">
          <span 
            className="text-xs font-bold text-slate-500 uppercase tracking-widest"
            style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
          >
            Cualidades clave
          </span>
          <div className="flex flex-wrap gap-2">
            {qualities?.map((quality, index) => (
              <span 
                key={index}
                className="px-3 py-1 text-xs font-medium rounded-full bg-slate-700 text-slate-300"
              >
                {quality}
              </span>
            ))}
          </div>
        </div>
      </div>
      
      {/* Hover effect */}
      <div 
        className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
        style={{
          background: `linear-gradient(135deg, ${color}10 0%, transparent 50%)`
        }}
      />
    </div>
  );
};

export default PositionCard;
